export default {
    CAREERS_LEAD: 'CAREERS_LEAD',
    PROVIDER: 'PROVIDER',
    CEC: 'CEC',
}
